import { render, staticRenderFns } from "./MallSupplier.vue?vue&type=template&id=1358db02"
import script from "./MallSupplier.vue?vue&type=script&lang=js"
export * from "./MallSupplier.vue?vue&type=script&lang=js"
import style0 from "./MallSupplier.vue?vue&type=style&index=0&id=1358db02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports